/**
 * Display original text or override display text with custom true/false display text.
 *
 * When custom overwrite is useful:
 * Say your checkbox option text in was some long question that needed to
 * be displayed on mobile for the technician. But the web form/pdf simply
 * needed to display yes/no text in a box because the underlying PDF already
 * displayed the long question in the background. This is where you could
 * use the custom overwrite to simply display True when that long question option
 * is checked true.
 */
const original = 'original';
const custom = 'custom';

export default {
  original,
  custom,
};
